"use client";

import { c as _c } from "react/compiler-runtime";
import { useMarkets } from "@opensea/app-kit";
import { parseAsArrayOf, parseAsStringLiteral, useQueryState } from "nuqs";
import { QUERY_PARAM_KEYS } from "./keys";
const useParser = () => {
  const $ = _c(2);
  const {
    markets
  } = useMarkets();
  let t0;
  if ($[0] !== markets) {
    t0 = parseAsStringLiteral(markets.map(_temp));
    $[0] = markets;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
export function useMarketQueryParam() {
  const $ = _c(8);
  const parser = useParser();
  let t0;
  if ($[0] !== parser) {
    t0 = parseAsArrayOf(parser).withDefault([]);
    $[0] = parser;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [values, setValues] = useQueryState(QUERY_PARAM_KEYS.markets, t0);
  let t1;
  if ($[2] !== setValues || $[3] !== values) {
    t1 = async function onSelectMarket(market) {
      const newValues = values.includes(market) ? values.filter(m => m !== market) : [...values, market];
      await setValues(newValues.length > 0 ? newValues : null);
    };
    $[2] = setValues;
    $[3] = values;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const onSelectMarket = t1;
  let t2;
  if ($[5] !== onSelectMarket || $[6] !== values) {
    t2 = {
      markets: values,
      onSelectMarket
    };
    $[5] = onSelectMarket;
    $[6] = values;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp(c) {
  return c.identifier;
}